import type { Theme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery/useMediaQuery';
import useTheme from '@material-ui/styles/useTheme';
import { useIsSkySlopeMobileApp } from '../common/utils';

export function isMobileUserAgent(navigator: Navigator) {
  const userAgent = navigator.userAgent.toLowerCase();
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
  return isMobile;
}

export function isTabletMediaQuery(navigator: Navigator) {
  const userAgent = navigator.userAgent.toLowerCase();
  const isTablet =
    /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
      userAgent
    );
  return isTablet;
}

export function useIsSmallScreenMediaQuery() {
  const theme = useTheme<Theme>();
  const isMobile = isMobileUserAgent(navigator);
  return useMediaQuery(theme.breakpoints.down('sm')) && isMobile;
}

export function useIsMediumScreenMediaQuery() {
  const theme = useTheme<Theme>();
  const isMobile = isMobileUserAgent(navigator);
  return useMediaQuery(theme.breakpoints.down('md')) && isMobile;
}

export function useIsSmallScreenOrMobileApp() {
  const isSmallScreen = useIsSmallScreenMediaQuery();
  const isMobileApp = useIsSkySlopeMobileApp();
  return isSmallScreen || isMobileApp;
}
